
































































































































































































































import { Vue, Component, Watch, Prop } from "@/shared/vuepack";
import {
  Expense,
  PossibleExpense,
  ExpenseRecurringType,
  ExpenseEligibility,
  FetchState,
  ExpenseEligibilityStatus,
  ExpenseEligibilityGroup,
  ExpenseCategory
} from "@/shared/types";
import CategoryPill from "@/shared/components/CategoryPill.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import Button from "@/shared/components/ui/Button.vue";
import { formatCurrency } from "@/shared/currency";
import * as _ from "lodash";
import { Validator } from "vee-validate";
import EvidenceUpload from "./EvidenceUpload.vue";
import LinkClaim from "@/shared/components/expenseV2/LinkClaim.vue";
import moment from "moment";
import LinkedClaimRow from "@/employee/components/healthcareExpenseV2/LinkedClaimRow.vue";
import { useThemeStore } from "@/shared/store/theme";
import { useExpenseV2Store } from "@/employee/store/expenseV2";
import { useClaimStore } from "@/employee/store/claim";

@Component ({
  components: {
    Button,
    CategoryPill,
    EvidenceUpload,
    RadioButton,
    LinkClaim,
    LinkedClaimRow
  }
})
export default class EditExpenseForm extends Vue {
 themeStore = useThemeStore();

 expenseStore = useExpenseV2Store();
 claimStore = useClaimStore();

  @Prop({required: true})
  expenseId: number;

  @Prop({required: true})
  transactionId: number;

  @Prop()
  eligibleAmount: number;

  @Prop({required: true})
  expense: any; // Expense

  @Prop({ required: false })
  claim: any; // Claim

  @Prop()
  transactionType: number;

  @Prop()
  addExpenseMode: boolean;

  @Prop()
  addClaimLink: boolean;

  @Prop({required: true})
  onSubmit: () => void;

  @Prop()
  editExpenseSource: string;

  @Prop()
  isExpensePartiallyReimbursed: boolean;


  ExpenseRecurringType = ExpenseRecurringType;
  isSubmitting = false;
  initialEligibleAmount = 0;
  linkedClaimIsOpen = false;
  showLinkClaimNote = false;
  $validator: Validator;
  linkClaimNote = null;
  linkClaimNoteLabel = "Add Note";
  formatCurrency = formatCurrency;
  showDeleteConfirmationModal = false;
  showIneligibleConfirmationModal = false;

  updatedExpense: Expense = null;
  categories = [
    {value: "medical", display: "Medical", category: ExpenseCategory.Medical},
    {value: "dental", display: "Dental", category: ExpenseCategory.Dental},
    {value: "pharmacy", display: "Pharmacy", category: ExpenseCategory.Pharmacy},
    {value: "eye", display: "Vision", category: ExpenseCategory.Eye},
    {value: "other", display: "Other", category: ExpenseCategory.Other}
  ];

  get canSubmitForm () { return this.$validator.errors.any() === false && this.isSubmitting === false; }

  @Watch("expense", { deep: true })
  updateExpenseAttachments () {
    this.updatedExpense.expenseEvidenceAttachments = this.expense.expenseEvidenceAttachments;
    this.updatedExpense.attachmentNames = this.expense.attachmentNames;
  }

  save (e) {
    e.preventDefault();
    const isAmountChanged = this.updatedExpense.amount !== this.initialEligibleAmount;
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      let linkRequest = {};
      if (this.addClaimLink) {
         linkRequest = {
          claimNumbers: [this.claim.claimNumber],
          comment: this.linkClaimNote,
        };
      }
      this.isSubmitting = true;
      this.expenseStore.updateExpense({
        expenseId: this.expenseId,
        expense: this.updatedExpense,
        expenseType: this.transactionType,
        isEligibleAmountChanged: isAmountChanged,
        hasLinkedClaim: this.addClaimLink,
        expenseLinkRequest: linkRequest
      } as any).then( id => {
        this.onSubmit();
        this.isSubmitting = false;
        if (!this.expenseId) {
          this.copyFormModel();
        }
      });
    });
  }

  addFamilyMember (e) {
    e.preventDefault();
  }

  addFiles (files) {
    this.updatedExpense.expenseEvidenceAttachments = files;
  }

  close (e) {
    e.preventDefault();
    this.onSubmit();
  }

  get eligibleAmountValidator () {
    return this.expense.transactionAmount ? this.validatorForTransactionExpense : this.validatorForManualExpense;
  }

  get validMinimumTransactionAmount () {
    return this.addExpenseMode || this.editExpenseSource === "confirmNew" ? 0.01 : 0;
  }

  get validMinimumManualAmount () {
    if (this.addExpenseMode || this.transactionType === 1) {
      return 0.01;
    }

    return 0;
  }

  get validatorForTransactionExpense () {
    return {
        required: true,
        decimal: 2,
        min_value_usd: this.validMinimumTransactionAmount,
        max_value_usd: this.expense.transactionAmount
    };
  }

  get validatorForManualExpense () {
    return {
        required: true,
        decimal: 2,
        min_value_usd: this.validMinimumManualAmount
    };
  }

  get hideLinkClaims () {
    return this.expense.id === null;
  }

  beforeMount () {
    this.claimStore.initializeLinkedClaimsState(this.expense.id);
    this.copyFormModel();
  }

  mounted () {
    this.claimStore.loadLinkedClaims(this.expense.id);

    if (this.addExpenseMode && this.claim) {
      this.populateFieldsFromClaim();
    }
  }

  populateFieldsFromClaim () {
    this.updatedExpense.name = this.claim.providerName;
    this.updatedExpense.dateOfService = this.claim.serviceDate;
    this.updatedExpense.amount = this.claim.memberResponsibility;
    this.updatedExpense.expenseCategory = this.claim.type;
  }

  copyFormModel () {
    const expense = this.expense;
    this.updatedExpense = {
        id: expense.id,
        name: expense.name,
        amount: this.eligibleAmount,
        reimbursedAmount: expense.reimbursedAmount,
        comment: expense.comment,
        expensePaid: expense.expensePaid,
        recurringType: expense.recurringType,
        expenseCategory: expense.expenseCategory,
        attachmentNames: expense.attachmentNames,
        eligibilityStatus: expense.expenseStatus,
        expenseEvidenceAttachments: expense.expenseEvidenceAttachments,
        institutionName: expense.institutionName,
        dateOfService: expense.dateOfService,
        transactionAmount: expense.transactionAmount,
        isManualExpense: expense.isManualExpense
    };
    this.initialEligibleAmount = this.updatedExpense.amount;

    if (typeof (this.updatedExpense.dateOfService) === "undefined") {
      this.updatedExpense.dateOfService = this.today;
    }
  }

  createDownloadLink (filename) {
    this.expenseStore.expenseAttachmentGet({
      expense: this.expense,
      attachmentName: filename
    } as any);
  }

  removeAttachment (attachmentName) {
    this.expenseStore.expenseAttachmentRemove({
      expense: this.expense,
      transactionType: this.transactionType,
      attachmentName
    });
  }

  @Watch("expenseId")
  onTransactionPropChange () {
    this.copyFormModel();
  }

  toggleLinkClaim (): void {
    this.linkedClaimIsOpen = !this.linkedClaimIsOpen;
  }

  formattedServiceDate (serviceDate: string): string {
    return moment(serviceDate).format("MMM D, YYYY");
  }
  isAltRow (rowId: number): boolean {
    return rowId % 2 === 0;
  }
  toggleLinkNote () {
    this.showLinkClaimNote = !this.showLinkClaimNote;
    this.linkClaimNoteLabel = this.showLinkClaimNote ? "Hide Note" : "Add Note";
  }

  get linkedClaimsLoaded (): boolean {
    return this.claimStore.linkedClaimsFetchState(this.expense.id) === FetchState.Loaded;
  }

  get hasLinkedClaims (): boolean {
    return this.claimStore.linkedClaims(this.expense.id)
      && this.claimStore.linkedClaims(this.expense.id).length > 0;
  }

  onLinkClaimsToExpenseUpdate () {
     this.claimStore.loadLinkedClaims(this.expense.id);
  }

  linkRemoved () {
    this.linkedClaimIsOpen = false;
  }

  onClose () {
    this.showDeleteConfirmationModal = false;
  }

  confirmDelete () {
    this.expenseStore.deleteExpense(this.expense.id);
    this.onClose();
    this.onSubmit();
  }

  enableDeleteConfirmationModal () {
    this.showDeleteConfirmationModal = true;
  }

  onConfirmIneligibleClose () {
    this.showIneligibleConfirmationModal = false;
  }

  confirmIneligibleStatus (e) {
    this.expenseStore.setIneligible(this.transactionId);
    this.onConfirmIneligibleClose();
    this.onSubmit();
  }

  enableIneligibleConfirmationModal () {
    this.showIneligibleConfirmationModal = true;
  }

  get showIneligibleButton (): boolean {
    return !this.expense.isManualExpense && this.transactionId !== null && this.transactionId > 0
    && this.expense.eligibilityStatus === ExpenseEligibility.Eligible;
  }
  get today (): string {
    return moment().format("MM/DD/YYYY");
  }
}
